import { createSelector } from '@reduxjs/toolkit';
import { head, prop, propOr } from 'ramda';

const selectMfaDevices = (state) => state.mfaDevices;

export const selectHasFetchedDevices = createSelector(
  [selectMfaDevices],
  prop('hasFetchedDevices')
);
export const selectDevices = createSelector([selectMfaDevices], propOr([], 'devices'));
export const selectMfaDevice = createSelector([selectDevices], head);
export const selectHasDevices = createSelector(
  [selectDevices],
  (devices) => Array.isArray(devices) && devices.length > 0
);
export const selectIsDevicesLoading = createSelector(
  [selectMfaDevices, selectHasFetchedDevices],
  (mfaDevices, hasFetchedDevices) => mfaDevices.loading || !hasFetchedDevices
);
export const selectDevicesError = createSelector(
  [selectMfaDevices],
  (mfaDevices) => mfaDevices.error
);
